@if (result(); as item) {
  <div class="flex flex-col gap-0.5">
    <div class="flex flex-row text-sm color-primary">
      <span>{{ item?.['kostenstelle'] }}</span>
    </div>
    @if (item?.['kontotext1']) {
      <div class="flex flex-row">
        <span class="font-semibold">{{ item?.['kontotext1'] }}</span>
      </div>
    }
    @if (item?.['kontotext2']) {
      <div class="flex flex-row">
        <span class="text-xs text-light">{{ item?.['kontotext2'] }}</span>
      </div>
    }
  </div>
}
